<button type="button" class="header" [class.expanded]="expanded()" [attr.aria-expanded]="expanded()" [attr.data-test]="testId() ?? null" (click)="toggle()">
    @if (icon()) {
        <i [class]="icon()"></i>
    }
    <span>{{ label() }}</span>
    <i class="pi pi-chevron-down chevron" [class.rotated]="expanded()"></i>
</button>

@if (expanded()) {
    <div class="children" @slideUpDown>
        @for (child of children(); track child.label) {
            @if (child.children) {
                <app-menu-group [label]="child.label" [icon]="child.icon" [children]="child.children" [testId]="child.testId" />
            } @else if (child.routerLink) {
                <app-menu-item [label]="child.label" [icon]="child.icon" [routerLink]="child.routerLink" [testId]="child.testId" />
            }
        }
    </div>
}
